import React from "react";

export function SkeletonCard({ variant = "wide" }) {
  const cls = variant === "wide"
    ? "aspect-video w-[260px] sm:w-[300px] md:w-[380px]"
    : "aspect-[9/16] w-[130px] sm:w-[160px] md:w-[200px]";
  return <div className={`${cls} rounded-xl bg-white/5 animate-pulse shrink-0`} />;
}

export function SkeletonRow({ variant = "wide" }) {
  return (
    <div className="px-3 sm:px-6 md:px-10 py-4">
      <div className="h-7 w-64 bg-white/5 rounded animate-pulse mb-4" />
      <div className="flex gap-3 overflow-hidden">
        {Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} variant={variant} />)}
      </div>
    </div>
  );
}

export function SkeletonHero() {
  return (
    <div className="relative w-full h-[60vh] min-h-[420px] md:h-[72vh] md:min-h-[520px] bg-white/5 animate-pulse" />
  );
}
